import { apiV1 } from './api';

const acceptCommandStep = ({ params }) =>
  apiV1.put(`/command_steps/${params.commandStepId}/accept`, params);
const rejectCommandStep = ({ params }) =>
  apiV1.put(`/command_steps/${params.commandStepId}/reject`, params);

export { acceptCommandStep, rejectCommandStep };
